export default {"src":"/_next/static/media/gnt.b3621ac8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};